import { useTranslations } from 'languages';
import { SearchForTagLayout } from 'modules/pages/searchForTag';
import { FC } from 'react';
import { SearchForTagPropsType } from 'types/pages/SearchForTag';
import { useGetCurrentCapitalizeTitle } from 'utils/hooks/useGetCurrentCapitalizeTitle';
import { siteText } from '../../siteText';

export const SearchForTag: FC<SearchForTagPropsType> = ({ tagData }) => {
  const t = useTranslations();

  const {
    slug_en = '',
    slug_ru = '',
    slug_uk = '',
    title_ru = '',
    title_uk = '',
    title_en = '',
  } = { ...tagData[0].seo };
  // @ts-ignore
  const tagForH1Title = useGetCurrentCapitalizeTitle({ title_ru, title_uk, title_en });

  const metaForSearchForTag = {
    title: t('metaPermanent.title', { tag: tagForH1Title }),
    description: t('metaPermanent.description', { tag: tagForH1Title }),
    keywords: t('metaPermanent.keyWord'),
    slugs: {
      slug_uk: slug_uk ? `tag/${slug_uk}` : '',
      slug_ru: slug_ru ? `tag/${slug_ru}` : '',
      slug_en: slug_en ? `tag/${slug_en}` : '',
    },
  };

  return (
    <SearchForTagLayout
      siteText={siteText}
      metaForSearchTag={metaForSearchForTag}
      tagData={tagData}
    />
  );
};
export default SearchForTag;
